import { connect } from 'react-redux'
import PositionalMediaButton2D from '../../components/2d/positionalMedia'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { SpriteSheetPositionalMediaButton3D } from '../../components/3d/positionalMedia3D'
import { MediaStates } from '../../constants'
import idx from 'idx'
import { lookupElement } from '../../methods/lookupElement'
import compose from 'recompose/compose'
import branch from 'recompose/branch'
import renderComponent from 'recompose/renderComponent'
import withPosition from '../withPosition/withPosition'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { INTERACTIVE_ELEMENT_OPTIONS } from '../../constants'
import { MEDIA_TYPES } from 'aria-viewer/tour/constants'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import { AUDIO_PLAY, AUDIO_STOP } from 'aria-viewer/audiomanager/audioManagerActions'

// for window tracking //
const POS_MEDIA = 'POS_MEDIA'

const mapStateToProps = (state, { id }) => {
    const el = lookupElement({ id, type: 'positionalMedia', state, toJS: true })
    const positionalMediaPlayers = state.getIn(['interactiveElements', 'positionalMediaPlayers']) || {}
    const forcePause = state.getIn(['interactiveElements', 'forceMediaPause']).forceBoolean
    const isMobile = state.getIn(['device', 'isDeviceMobile'])
    const videoState = idx(positionalMediaPlayers, _ => _[id].state) || MediaStates.PAUSE
    const opacity = videoState === MediaStates.PAUSE ? 0 : 1
    const enable3D = state.getIn(['interactiveElements', 'enable3D'])
    const autoplay = state.getIn(['audioManager', 'autoplay'])
    const isRegistrationModalOpen = state
        .getIn(['modal', 'modalStack'])
        .some(modal =>
            [ModalContentTypes.WELCOME_REGISTRATION, ModalContentTypes.REGISTRATION].includes(modal.content.type)
        )

    if (forcePause) {
        // Pause all players
        for (const player of Object.values(positionalMediaPlayers)) {
            player && player.pause && player.pause()
        }
    }

    return {
        ...el,
        autoplay: el.autoplay && autoplay,
        opacity,
        state: videoState,
        positionalMediaPlayers,
        forcePause,
        isMobile,
        enable3D,
        coordinates: el.position,
        isRegistrationModalOpen,
        videoState,
    }
}

// Note custom_ui should only hide the rendering of the MediaButton. The video content should continue to render.
const shouldRenderComponent = Component => ({ custom_ui, ...props }) => {
    return custom_ui == true ? null : <Component custom_ui={custom_ui} {...props} />
}

const mergeProps = (state, action, ownProps) => {
    return {
        ...state,
        ...ownProps,
        onClick: event => {
            // Constrain to only one positional media player playing at a time
            for (const [playerID, player] of Object.entries(state.positionalMediaPlayers)) {
                if (playerID == ownProps.id) {
                    player && player.play && player.play()
                } else {
                    player && player.pause && player.pause()
                }
            }
        },
    }
}

const injectStore = (stores, { id }) => ({
    progress: stores.streams.mediaProgress.has(id) ? stores.streams.mediaProgress.get(id).progress : 0,
})

const stopProps = function(Component) {
    let isPlaying = true
    let isPaused = false
    return class extends React.Component {
        shouldComponentUpdate({ progress, state, positionalMediaPlayers }) {
            let stopAllHotspots = this.props.supplementalMediaVisible || this.props.isRegistrationModalOpen
            for (const [playerID, player] of Object.entries(this.props.positionalMediaPlayers)) {
                if (playerID == this.props.id) {
                    window[POS_MEDIA] = player.isPlaying() ? AUDIO_PLAY : AUDIO_STOP
                    if (stopAllHotspots && isPlaying) {
                        isPaused = !player.isPlaying()
                        player.pause()
                        isPlaying = false
                    }
                    if (!stopAllHotspots && !isPlaying) {
                        if (!isPaused) player.play()
                        isPlaying = true
                    }
                }
            }
            if (this.init) {
                return (
                    progress !== this.props.progress ||
                    state !== this.props.state ||
                    positionalMediaPlayers !== this.props.positionalMediaPlayers
                )
            } else {
                this.init = true
                return true
            }
        }
        render() {
            return <Component {...this.props} />
        }
    }
}

// TODO: We should use something more common across the board ie position
const WithMeshPosition = WrappedComponent => ({ initialCenter, ...props }) => (
    <WrappedComponent meshPosition={initialCenter} initialCenter={initialCenter} {...props} />
)

export default compose(
    connect(mapSelectorsToProps(['supplementalMediaVisible']), null),
    connect(mapStateToProps, null, mergeProps),
    shouldRenderComponent,
    inject(injectStore),
    observer,
    withPosition,
    WithMeshPosition,
    stopProps,
    branch(
        ({ enable3D, contextType }) => enable3D && contextType !== INTERACTIVE_ELEMENT_OPTIONS.CONTEXT.context2D,
        renderComponent(SpriteSheetPositionalMediaButton3D),
        renderComponent(PositionalMediaButton2D)
    )
)()
